/* globals process */

import axios from "axios";
import store from "@/plugins/store/store";
import UtilsService from "@/services/UtilsService";

export default () => {
  // API url has to be defined
  if (!process.env.VUE_APP_API_URL) {
    throw new Error("VUE_APP_API_URL environment variable not specified");
  }

  // Handle response the axios way
  const ax = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  });

  // Handle response the axios way
  ax.interceptors.response.use(
    // If response is successfull, send it through
    response => {
      const newToken = response.headers.authorization;
      // if (newToken)
      //   store.dispatch("setToken", newToken);
      return response;
    },
    // If error happened:
    error => {
      if (error.response) {
        // And the error type is unauthorized
        if (error.response.status && error.response.status === 401) {
          // If the token is in the store
          if (store.state.isUserLoggedIn || store.state.token || store.state.user) {
            // Clear the token, user data and cached module state
            store.dispatch("setToken", null);
            store.dispatch("setUser", null);
            store.dispatch("clearAll");
          }
          // Return to login page
          UtilsService.redirectToLogin();
          return error.response;
        }
        return error.response;
      } else {
        return error;
      }
    }
  );
  return ax;
};



// WEBPACK FOOTER //
// ./src/services/Api.js